import { useParams } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { Documentation } from '../Documentation/Documentation';
import { DocumentationV3 } from '../DocumentationV3/DocumentationV3';
import React from 'react';
import { LagoonContext } from '@src/AppContext';
import { DocumentationV2 } from '../DocumentationV2';

export const DocumentationHandler = () => {
  const lagoonContext = React.useContext(LagoonContext);
  const featureToggles = lagoonContext?.getTable('feature-toggles');
  const documentationV3Toggle = featureToggles?.getRow(
    'DOCUMENTATION_V3_TOGGLE'
  )?.enabled;
  const { service } = useParams();
  const isSuperconnector = service === 'superconnector';

  if (isSuperconnector) {
    return !documentationV3Toggle ? <DocumentationV2 /> : <DocumentationV3 />;
  }

  return <Documentation />;
};
